import React from "react";
import { useGetUtilityDataByFeatureModuleContext } from "../dataloader";
import UtilityDataModule from "../enums/UtilityDataModule";
import ContextEntityType from "../enums/ContextEntityType";
import UtilityDataFeatureType from "../enums/UtilityDataFeatureType";
import { executeStringAsScript } from "../utils";
import { AnyObject } from "../../global";

interface LogEventTriggerConfigPropsType {
  registrationId: string;
  module?: UtilityDataModule;
  contextEntityType?: ContextEntityType;
  contextEntityId?: string;
}

export default function useLogEventTriggerConfig(props: LogEventTriggerConfigPropsType) {
  const { data: eventTriggerDataObj } = useGetUtilityDataByFeatureModuleContext({
    registrationId: props.registrationId,
    featureType: UtilityDataFeatureType.EVENT_TRIGGER,
    module: props.module,
    contextEntityType: props.contextEntityType,
    contextEntityId: props.contextEntityId
  });

  const triggerEvent = React.useCallback(
    ({
      retryCount = 0,
      retryInterval = 500,
      dataObj
    }: {
      retryCount?: number;
      retryInterval?: number;
      dataObj?: AnyObject;
    }) => {
      const scriptToExec = eventTriggerDataObj?.value?.script || "";
      const result = executeStringAsScript(scriptToExec, dataObj);
      if (retryCount > 0 && !result) {
        const timeOut = setTimeout(() => {
          triggerEvent({ retryCount: retryCount - 1, retryInterval });
          clearTimeout(timeOut);
        }, retryInterval);
      }
    },
    [eventTriggerDataObj?.value?.script]
  );

  return { triggerEvent };
}
